export const CONFIG = {
    client_name : "stw_hamm",
    client_display_name : "Stadtwerke Hamm",
    modal_confirm_button_label : "übernehmen",
    country : 'de',
    base_asset_url : `https://esr.fe-bis.de/de/stw_hamm/`,
    plz_validation : (plz : string) => plz.length == 5,
    plz_default: "59067",
    foerderung : true,
    development_mode: false,
}